/**
 *  this is for stuff that is done often in vanillajs or its vanillajs that can
 *  be used often in mcd or site-ui
 */
module.exports = {

  isElementFixedOrChildOfFixedElement: function isElementFixedOrChildOfFixedElement(element) {
    let tempElement = element;
    if (window.getComputedStyle(tempElement).position === 'fixed') {
      return true;
    }

    while (tempElement.parentElement) {
      if (window.getComputedStyle(tempElement).position === 'fixed') {
        return true;
      }
      tempElement = tempElement.parentElement;
    }
    return false;
  },

  /**
   * @param element
   * @param query {string}
   * @returns {boolean}
   */
  isElementOrHasElement: function isElementOrHasElement(element, query) {
    let tempElement = element;
    while (tempElement.parentElement) {
      if (tempElement.parentElement.querySelector(query)) {
        return true;
      }
      tempElement = tempElement.parentElement;
    }
    return false;
  }
};
